import React from 'react'
import {Flex, Icon, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage} from 'react-intl'
import {AlertTriangleIcon} from '../../../components/icons'

/* Styles */
import {useStoreLocatorStyles} from '../styles/storeLocatorStyles'

/* Hooks */
import {useStoreLocator} from '../../../contexts/store-locator-context';

const StoreLocatorNoResults = () => {
    /* Styling */
    const styles = useStoreLocatorStyles()
    const noResultsStyling = styles?.components?.noResults
    const {noSearchResults} = useStoreLocator()

    return (
        <>
            {noSearchResults &&
                <Flex {...noResultsStyling.container} mb={{base: '20px', lg: undefined}}>
                    <Flex alignItems="center" gap={2}>
                        <Icon as={AlertTriangleIcon} boxSize="20px" />
                        <Text {...noResultsStyling.title}>
                            <FormattedMessage
                                defaultMessage='No Results Found'
                                id='store_locator.noResults.title'
                            />
                        </Text>
                    </Flex>
                    <Text {...noResultsStyling.subTitle}>
                        <FormattedMessage
                            defaultMessage="We couldn't find any stores matching your search. Try checking the spelling or searching for a nearby city."
                            id='store_locator.noResults.sub_title'
                        />
                    </Text>
                </Flex>
            }
        </>
    )
}

export default StoreLocatorNoResults
